import { Ref, shallowRef } from 'vue';

export interface LoadingStore {
  darkMode: Ref<boolean>;
  toggleDarkMode: (state: boolean) => void;
}

const darkMode = shallowRef<boolean>(false);

const useDarkStore = (): LoadingStore => {
  const toggleDarkMode = (state: boolean): void => {
    darkMode.value = state;
    document.documentElement.classList.toggle('dark', darkMode.value);
    localStorage.setItem('dark-mode', JSON.stringify(darkMode.value));
  };

  return {
    darkMode,
    toggleDarkMode,
  };
};

export default useDarkStore;
